var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-form', [_c('el-form-item', [_c('creation-uploader', { staticClass: "creation-uploader", attrs: { "multiple": true, "file-list": _vm.fileList, "on-success": _vm.onUploadSuccess, "on-change": _vm.onFileChange, "on-remove": _vm.onFileRemove } })], 1), _vm._v(" "), _c('div', { staticClass: "dialog-footer", staticStyle: { "text-align": "right" } }, [_c('el-button', { attrs: { "type": "primary" }, on: { "click": _vm.submit } }, [_vm._v("导入")])], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };